import { NO_REGIONS_NOTE, ScopeNote } from '../../primitives/scope/ScopeNote';
import { useOwnRegions } from '../../primitives/scope/use-own-regions';

/**
 * A line under the Overview header that explains a default the viewer did not
 * choose. On All regions: a viewer assigned no region is seeing everything. On a
 * region: a viewer assigned several is looking at their first, not all of them.
 */
export function OverviewScopeNote({ regionId }: { regionId?: string }) {
  const { own, noRegions } = useOwnRegions();
  if (!regionId) return noRegions ? <ScopeNote>{NO_REGIONS_NOTE}</ScopeNote> : null;
  if (own.length > 1 && own[0].id === regionId) {
    return <ScopeNote>Showing 1 of your {own.length} regions</ScopeNote>;
  }
  return null;
}
